import React, { ReactElement } from 'react';
import './select.scss';

interface SelectOption {
  name: string;
  value: string;
}

interface SelectProps {
  id: string;
  label: string;
  options: SelectOption[];
  name: string;
  registerRef: (arg: any) => void;
  action?: (arg: any) => void;
  preIcon?: ReactElement;
  value?: string;
}

export default function Select({
  id,
  label,
  options,
  name,
  registerRef,
  action,
  preIcon = <></>,
  value,
}: SelectProps): React.ReactElement {
  return (
    <div className='select'>
      {label && <label htmlFor={name}>{label}</label>}
      {preIcon}
      <div className='field'>
        <select
          name={name}
          aria-label='label'
          ref={registerRef}
          onChange={(event) => {
            if (action) {
              action(event);
            }
          }}
          value={value}
        >
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={!option.value}
            >
              {option.name}
            </option>
          ))}
        </select>
        <i className='arrow down' />
      </div>
    </div>
  );
}
